import { disableCalendarModuleHotkeys } from '../utils/bindCalendarModuleHotKeys';
import { disableCalendarModuleContentHotkeys } from '../utils/bindCalendarModuleContentHotKeys';
import { onRequestModuleCommand } from 'owa-calendar-module-command';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { orchestrator } from 'satcheljs';
import { unlockSelectedItem } from 'owa-calendar-surface';
import { disableAppModuleHotkeys } from 'owa-app-module/lib/utils/moduleHotKeys';

orchestrator(onRequestModuleCommand, actionMessage => {
    // disable global hotkeys so we don't accidentally invoke compose or navigate the view while popups are open
    disableCalendarModuleHotkeys();
    disableCalendarModuleContentHotkeys();
    disableAppModuleHotkeys();

    // unlock the selected item once the peek has successfully opened.
    if (
        actionMessage.moduleCommand == 'Open_ItemPeek' ||
        actionMessage.moduleCommand == 'Open_ReadPanel' ||
        actionMessage.moduleCommand == 'Open_QuickCompose' ||
        actionMessage.moduleCommand == 'Open_MobilityCompose'
    ) {
        unlockSelectedItem(surfaceStore);
    }
});
